import i18n from "../../i18n";

const validate = values => {
    const errors = {};
    const ADDRESS_STREET_LENGTH = 250;
    const ADDRESS_CITY_LENGTH = 50;
    const ADDRESS_POSTAL_CODE_LENGTH = 20;
    if (!(values.address && values.address.trim())) {
      errors.address = i18n.t('validation.required');
    }
    else if(values.address && values.address.trim().length > ADDRESS_STREET_LENGTH) {
      errors.address = i18n.t('validation.maxLengthExceeded');
    }
    if (!(values.city && values.city.trim())) {
      errors.city = i18n.t('validation.required');
    }
    else if(values.city && values.city.trim().length > ADDRESS_CITY_LENGTH) {
      errors.city = i18n.t('validation.maxLengthExceeded');
    }
    else if(values.city && !/^([^0-9]*)$/.test(values.city)) {
      errors.city = i18n.t('validation.numbersNotAllowed');
    }
    if (!(values.postalCode && values.postalCode.trim())) {
      errors.postalCode = i18n.t('validation.required');
    }
    else if(values.postalCode && values.postalCode.trim().length > ADDRESS_POSTAL_CODE_LENGTH) {
      errors.postalCode = i18n.t('validation.maxLengthExceeded');
    }
    else if(values.country && values.country === 'BR') {
      if(values.postalCode && !/^([0-9]{5}-[0-9]{3})$/.test(values.postalCode)) {
        errors.postalCode = i18n.t('validation.postalCodeIncorrect');
      }
    }
    if (!values.state) {
        errors.state = i18n.t('validation.required');
    }
    if (!values.country) {
        errors.country = i18n.t('validation.required');
    }
    return errors;
  };
  
  export default validate;
  